import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge has to know the names globals.css adds to the theme, or it
// takes `text-caption` for a colour (and drops it beside `text-muted-foreground`)
// and doesn't let `rounded-lg` replace `rounded-card`.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["caption", "display"],
      radius: ["field", "header", "panel", "card"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
